export default __webpack_public_path__ + "static/media/SAS Alert Tone 13.1ead125c.mp3";